import React from "react"
import PropTypes from "prop-types"
import { HeadingBlock } from "containers"
import { ColumnGroup, Section } from 'AtomicComponents'

const HeadingSectionBlock = ({
  backgroundColor,
  ...props
}) => (
  <ColumnGroup
    {...{ backgroundColor }} >
    <Section
      textAlign={"center"}
      textAlignMobile={"center"} >
      <HeadingBlock {...props} white />
    </Section>
  </ColumnGroup>
)

HeadingSectionBlock.propTypes = {
  backgroundColor: PropTypes.string
}

export default HeadingSectionBlock



// WEBPACK FOOTER //
// ./src/blocks/heading-section/index.jsx